import { render, staticRenderFns } from "./LayoutDashboard.vue?vue&type=template&id=a557dfc2&"
import script from "./LayoutDashboard.vue?vue&type=script&lang=js&"
export * from "./LayoutDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports